import _default from './Sticky';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Sticky/index.js
// module id = 3318
// module chunks = 0